/* eslint-disable */
interface IPhotoPreviewOptions extends HTMLAnchorElement {
	src: string;
}

export function createPhotoPreview({
	className = "",
	src = "",
	...rest
}: Partial<IPhotoPreviewOptions>): HTMLAnchorElement {
	const container = Mapy.Util.node("a", {
		className: `ui-photo-preview ${className}`,
		innerHTML: ``,
		...rest,
	}) as HTMLAnchorElement;
	const img = Mapy.Util.node("img", { src, crossOrigin: "anonymous" });
	container.appendChild(img);

	return container;
}
